import {apiFetch} from "./General";

export const getLogo = (callback, errorCallback) => {

    apiFetch(`partnerlogo/`, '', callback, errorCallback);
}
